import SeachInput from 'components/form/SeachInput';
import Card from 'components/Layout/Card';
import Profile from 'components/Layout/Profile';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { icons } from 'utils/constants';
import '../FollowUpData/ManualFollowUpData.scss';

const UnpaidFollowUps = () => {
  const navigate = useNavigate();
  const [childTabType, setChildTabType] = useState('all');
  const activeClass = 'p-2 color-new-car text-14-500-18 active-tab-underline';
  const inActiveClass = 'p-2 color-6866 text-16-500 text-14-500-18 pointer';
  const leadColorWithBG = (values = '') => {
    if (values) {
      if (values === 'Pending') {
        return 'status-pending';
      } else if (values === 'Send') {
        return 'status-send';
      } else if (values === 'Failed') {
        return 'status-failed';
      } else {
        return 'status-default';
      }
    }
  };

  const userList = [
    {
      name: 'John Doe',
      email: 'john.doe@example.com',
      phone_number: '+1 234 567 890',
      profile_photo: 'https://via.placeholder.com/134',
      status: 'Send',
    },
    {
      name: 'Jane Smith',
      email: 'jane.smith@example.com',
      phone_number: '+44 123 456 789',
      profile_photo: 'https://via.placeholder.com/134',
      status: 'Failed',
    },
    {
      name: 'Mike Johnson',
      email: 'mike.j@example.com',
      phone_number: '+91 98765 43210',
      profile_photo: 'https://via.placeholder.com/134',
      status: 'Pending',
    },
  ];

  return (
    <Card className="cpt-10 cpe-20 cps-20 cpb-10 h-100">
      <div className="d-flex align-items-center justify-content-between cpb-5 ">
        <div className="d-flex align-items-center gap-2">
          <img
            src={icons.leftArrow}
            alt="back"
            className="h-21 pointer"
            onClick={() => {
              navigate(-1);
            }}
          />
          <div className="table-title">{'Follow-Up Details'}</div>
        </div>

        <div className="d-flex align-items-center flex-wrap gap-3">
          <div style={{ width: '220px' }}>
            <SeachInput
              placeholder="Search"
              value=""
              onChange={() => {}}
              onKeyDown={() => {}}
              onClick={() => {}}
              isSearchPointer
            />
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap gap-2 border-bottom">
        <div
          className={childTabType === 'all' ? activeClass : inActiveClass}
          onClick={() => {
            setChildTabType('all');
          }}
        >
          All (100)
        </div>

        <div
          className={childTabType === 'send' ? activeClass : inActiveClass}
          onClick={() => {
            setChildTabType('send');
          }}
        >
          Send (21)
        </div>

        <div
          className={childTabType === 'failed' ? activeClass : inActiveClass}
          onClick={() => {
            setChildTabType('failed');
          }}
        >
          Failed (10)
        </div>

        <div
          className={childTabType === 'pending' ? activeClass : inActiveClass}
          onClick={() => {
            setChildTabType('pending');
          }}
        >
          Pending (10)
        </div>
      </div>

      <div className="cmt-15">
        <div className="row">
          {userList?.map((elem, index) => {
            return (
              <div className="col-md-6 col-lg-6 col-xl-4 cmb-14" key={index}>
                <div className="cps-14 cpt-16 cpe-14 cpb-14 border border-rounded rounded-1 position-relative d-flex gap-3">
                  <div className="">
                    <Profile
                      text={elem?.name}
                      url={elem?.profile_photo}
                      size="s-134"
                      isS3UserURL
                    />
                  </div>
                  <div className="width-60">
                    <div className="text-14-400-18 color-48c0 cmb-15">
                      {elem?.name}
                    </div>
                    <div className="text-10-400-18 color-6866 d-flex align-items-center text-break gap-2 cmb-15">
                      <i className="bi bi-envelope" />
                      {elem?.email}
                    </div>

                    <div className="text-14-400-18 color-6866 d-flex align-items-center gap-2 cmb-10">
                      <i className="bi bi-telephone" /> {elem?.phone_number}
                    </div>

                    <div className="text-14-400-18 color-6866 d-flex align-items-center gap-2">
                      <span
                        className={`${leadColorWithBG(
                          elem?.status
                        )} text-14-400-17`}
                      >
                        {elem?.status}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Card>
  );
};

export default UnpaidFollowUps;
